import Btn from "@components/Btn"
import { HOME_BUTTON_ONE_TEXT, VERSION_LITE, WALLED_GARDEN, HP_ANIMATIONS, HP_ANIMATION_TYPE  } from "@lib/constants";
import { trackUsageClick } from "@lib/helpers/reporting";
import { useEffect } from "react";
import { useRouter } from "next/router";
import { useSelector } from "react-redux";

import { useI18n } from '@lib/i18n';

import { staggerAnimations } from '@lib/helpers';
import { initTriggeredAnimations } from '@lib/helpers/blockAnimations';

export default function PersonaliseButton({isAdvisor = false}) {
	const { t } = useI18n();
	const router = useRouter();

	const { prospectusId, authenticated } = useSelector((state) => state.user);

	const handleClick = () => {
		trackUsageClick('personalisation');

		if (prospectusId) {
			router.push('/personalise?refresh=true&isSaved=true');
		} else {
			router.push('/personalise');
		}
	};

	const animationClass = HP_ANIMATIONS && HP_ANIMATION_TYPE
	? `animate ${HP_ANIMATION_TYPE} hp-has-triggered-animation`
	: '';

	const animationData =
	HP_ANIMATIONS && HP_ANIMATION_TYPE
		? {
				'data-hp-trigger-selector': '',
				'data-hp-triggered-animation':
					HP_ANIMATION_TYPE,
				'data-hp-trigger-event':
					'viewport',
				'data-hp-triggered-played' : '0',
			}
		: {};

	useEffect(() => {
		staggerAnimations();
		initTriggeredAnimations();
	}, []);

	if (isAdvisor) {
		return (
			<Btn
				onClick={handleClick}
				customClass={['primary', 'mb-2', 'primary--home', 'BtnPrimary_Home', `${animationClass}`]}
				{...animationData}
			>
				{t('home.createProspectus', HOME_BUTTON_ONE_TEXT)}
			</Btn>
		);
	}

	if (WALLED_GARDEN && authenticated && prospectusId) {
		return;
	}

	if (VERSION_LITE) {
		return;
	}

	return (
		<Btn
			onClick={handleClick}
			customClass={['primary', 'mb-2', 'primary--home', 'BtnPrimary_Home', `${animationClass}`]}
			{...animationData}
		>
			{t('home.createProspectus', HOME_BUTTON_ONE_TEXT)}
		</Btn>
	);
}
